import React from "react";

function InfoIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="60"
      height="60"
      viewBox="0 0 60 60"
    >
      <g
        id="Group_27886"
        data-name="Group 27886"
        transform="translate(-530 -929)"
      >
        <circle
          id="Ellipse_40"
          data-name="Ellipse 40"
          cx="30"
          cy="30"
          r="30"
          transform="translate(530 929)"
          fill="#d4e3ed"
        />
        <path
          id="Path_18517"
          data-name="Path 18517"
          d="M14.5,27A12.5,12.5,0,1,1,27,14.5,12.5,12.5,0,0,1,14.5,27Zm0-2.5a10,10,0,1,0-10-10A10,10,0,0,0,14.5,24.5ZM13.25,8.25h2.5v2.5h-2.5Zm0,5h2.5v7.5h-2.5Z"
          transform="translate(546 945)"
        />
      </g>
    </svg>
  );
}

export default InfoIcon;
